import tw, { css, styled } from "twin.macro";
import { keyframes } from "styled-components";
import IconStore from "@iconsV2/Interrface/store.svg?react";

const slideIn = keyframes`
  from { opacity: 0; transform: translateY(-0.75rem); }
  to { opacity: 1; transform: translateY(0); }
`;

const shrink = keyframes`
  from { transform: scaleX(1); }
  to { transform: scaleX(0); }
`;

export const StyledToaster = styled.div`
  ${tw`fixed z-[60] top-m left-1/2 -translate-x-1/2 w-[calc(100% - 2rem)] max-w-[25rem] grid gap-s pointer-events-none`}
  top: max(1rem, env(safe-area-inset-top));
`;

export const StyledToast = styled.div`
  ${tw`relative overflow-hidden flex items-center gap-sm bg-neutral-100 rounded-2xl py-sm px-m shadow-elevation-2 pointer-events-auto`}
  animation: ${slideIn} 200ms ease-out;

  &:hover > span {
    animation-play-state: paused;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const StyledIconBox = styled.div`
  ${tw`h-9 w-9 shrink-0 grid place-content-center rounded-xl bg-secondary-90`}
`;

export const StyledIconStore = styled(IconStore)`
  ${tw`h-[1.125rem] w-[1.125rem]`}

  & path {
    ${tw`fill-secondary-50`}
  }
`;

export const StyledProgress = styled.span<{ $duration: number }>`
  ${tw`absolute bottom-0 left-0 h-1 w-full bg-secondary-50 origin-left`}
  ${({ $duration }) => css`
    animation: ${shrink} ${$duration}ms linear forwards;
  `}
`;
